import React from "react";
import { FaPaperPlane } from "react-icons/fa";

// Get the number seconds that have passed since midnight, UTC
const getSecondsSinceMidnight = () => {
  const now = new Date();
  const x = now.getUTCHours() * 3600 + now.getUTCMinutes() * 60 + now.getUTCSeconds();
  console.log(x);
  return x;
};
// Get the date like YYMMDD
const getDateYYMMDD = () => {
  const now = new Date();
  const year = now.getUTCFullYear().toString().slice(-2);
  const month = (now.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = now.getUTCDate().toString().padStart(2, '0');
  return `${year}${month}${day}`;
};


const IvaoButton = ({ origin, destination, aircraftType, callsign, route="None" }) => {
  const handleOpenIvao = () => {
    // 1. Create the Data Transfer Object (DTO)

    const flightPlanDTO = {

      callsign: callsign ? callsign.toUpperCase() : undefined,
      flightRules: "I",
      flightType: "S",      
    
      aircraftNumber: "1",
      aircraftId: "B77L",
      aircraftWakeTurbulence: "H",
      aircraftEquipments: ["D","F","G","L","O","W"],
      aircraftTransponderTypes: ["C"],

      departureId: origin,
      departureTime: (getSecondsSinceMidnight() + 600).toString(),

      cruisingSpeedType: "N",
      cruisingSpeed: "322",
      altitudeType: "F",
      altitude: "310",
      route: route,

      arrivalId: destination,
      eet: "10800",
      remarks: " DOF/" + getDateYYMMDD().toString() + " / FedEx Express Virtual / FDXVA.ORG",
      endurance: "20999",
      pob:"42",




      


      
    };

    // 2. Convert the object to a JSON string
    const jsonString = JSON.stringify(flightPlanDTO);

    // 3. Base64 encode the JSON string
    const base64Data = btoa(jsonString);

    // 4. Append to the correct IVAO endpoint
    const fullUrl = `https://fpl.ivao.aero/flight-plans/create?flightPlan=${base64Data}`;

    // 5. Open in a new tab
    window.open(fullUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <button 
      onClick={handleOpenIvao}
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#0d2c99", 
        color: "white",
        border: "none",
        padding: "10px 16px",
        borderRadius: "4px",
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: "bold"
      }}
    >
      <FaPaperPlane style={{ marginRight: "8px" }} />
      IVAO
    </button>
  );
};

export default IvaoButton;